/**
 * 事件监听
 */
import MatomoUtils from "./MatomoUtils";

export default {
    /**
     * 事件类型
     */
    eventTypes:{
       clickEvent: "click", //点击事件
    },
    /**
     * 属性keys  category, action, name, value
     */
    propsKeys:{
        data_m_event:'data_m_event', // 事件所有的key, 使用逗号分隔 e.g <a data_m_event="事件分类, 事件行为, 事件名称, 事件值"/>
        data_m_category: "data_m_category",  // 事件分类 - require
        data_m_action: "data_m_action",  // 事件行为 - require
        data_m_name: "data_m_name",  // 事件名称 - require
        data_m_value: "data_m_value",  // 事件值 - options
        data_m_extra: "data_m_extra",  // 额外的参数 - options
    },


    /**
     * 增加事件监听
     */
    addAllEventsMonitor(){

        const that  = this;
        document.addEventListener(this.eventTypes.clickEvent, function (event) {
            const eventTarget = event.target;
            if(!eventTarget){
                console.log('未找到事件响应控件');
            }
            // 处理节点事件
            that.handleNodeEvent(eventTarget);
        })
    },

    /**
     * 事件处理
     */
    handleNodeEvent(eventTarget){
        const events = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_event);
        let eventCategory = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_category);
        let eventAction = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_action);
        let eventName = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_name);
        let eventValue = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_value);
        // 事件列表处理
        if(events && events.length > 0){
            const eventValueList = events.split(',');
            if(eventValueList && eventValueList.length > 0){
                eventCategory = eventCategory ? eventCategory :eventValueList[0];
                eventAction = eventAction ? eventAction :eventValueList[1];
                eventName = eventName ? eventName :eventValueList[2];
            }
            if(eventValueList.length  >= 4){
                eventValue = eventValue ? eventValue :eventValueList[3];
            }
        }

        // 额外参数处理 lzb 2020-08-10 新增
        let eventExtraStr = this.getAttributeFormNode(eventTarget, this.propsKeys.data_m_extra);
        if(eventExtraStr && eventExtraStr.length != 0){
            eventCategory = eventExtraStr + '.' + eventCategory;
            eventAction = eventExtraStr + '.' + eventAction;
            eventName = eventExtraStr + '.' + eventName;
        }

        // 发送请求
        MatomoUtils.sendEndPointEvent(eventCategory, eventAction, eventName, eventValue);
    },


    /**
     * 从控件中获取属性值
     */
    getAttributeFormNode(node, key){
        const has = node.hasAttribute(key);
        if(!has){
            return null;
        }
        const value = node.getAttribute(key);
        return  value;
    }



}